import { COLORES_SEMANTICOS, type ColorSemantico } from "../../shared/types";
import { resolverColorSemantico } from "../lib/colorSemantico";

// Grilla fija de 8 swatches — vocabulario controlado, nunca un
// <input type="color"> de hex libre. Usado para Materia/Fuero/Estado
// Procesal, a diferencia del color libre existente de Áreas de Práctica.
export function SelectorColorSemantico({
  valor,
  onCambiar,
}: {
  valor: ColorSemantico | null | undefined;
  onCambiar: (color: ColorSemantico) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Seleccionar color">
      {COLORES_SEMANTICOS.map((color) => {
        const seleccionado = valor === color;
        return (
          <button
            key={color}
            type="button"
            onClick={() => onCambiar(color)}
            aria-label={color}
            aria-pressed={seleccionado}
            className={`h-7 w-7 rounded-full transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2 ${resolverColorSemantico(color).punto} ${
              seleccionado ? "scale-110 ring-2 ring-principal ring-offset-2" : "hover:scale-105"
            }`}
          />
        );
      })}
    </div>
  );
}
